// Returns an in-app web route for the legal documents so they render as a normal
// page (LegalPage component) instead of opening the original PDF in a new tab.
//
// The signature is kept (type, language) for back-compat with existing call sites.
// `language` is no longer required because LegalPage picks the language from the
// LanguageContext at render time, but it's accepted to avoid touching every caller.

export const getLegalDocUrl = (type /* , language */) => {
  if (type === 'terms') return '/legal/terms';
  if (type === 'privacy') return '/legal/privacy';
  return null;
};

export const LEGAL_LABELS = {
  terms: {
    ar: 'الشروط والأحكام',
    en: 'Terms & Conditions',
    fr: 'Conditions générales'
  },
  privacy: {
    ar: 'سياسة الخصوصية',
    en: 'Privacy Policy',
    fr: 'Politique de confidentialité'
  }
};
